// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__13Yd9"};